export enum ComposeSource {
    Mail,
    Calendar,
    PeopleHub,
    PeopleCard,
}
